import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EntityToArrayPipe } from './entity-to-array.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [EntityToArrayPipe],
  exports: [EntityToArrayPipe]
})
export class NgrxModule {}
